import React, { Component } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

const bgImage = toAbsoluteUrl("/media/bg/bg-9.jpg");

class Maintenance extends Component {
  componentDidMount() {
    document.title = "SPMI | Maintenance";
  }

  handleRefresh = () => {
    window.location.reload();
  };

  render() {
    return (
      <div className="d-flex flex-column flex-root">
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
          id="kt_login"
        >
          <div
            className="flex-row-fluid d-flex flex-column position-relative p-5 p-sm-10 p-lg-15 overflow-hidden"
            style={{
              backgroundImage: `url(${bgImage})`,
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <div className="d-flex flex-column-fluid flex-center mt-5 mt-lg-0">
              <div
                className="login-form bg-white rounded-lg shadow-lg p-5 p-sm-10 text-center"
                id="kt_maintenance_page"
                style={{ maxWidth: "560px", width: "100%" }}
              >
                <div className="text-center mb-8">
                  <img
                    alt="Logo"
                    className="max-h-100px"
                    src={toAbsoluteUrl("/media/logos/logo-letter.png")}
                  />
                </div>

                <div className="symbol symbol-80 symbol-light-danger mb-8 mx-auto">
                  <span className="symbol-label font-size-h1">
                    <span className="fa fa-cog fa-spin" />
                  </span>
                </div>

                <h1 className="font-size-h1 text-danger font-weight-boldest mb-5">
                  Sistem Sedang Dalam Pemeliharaan
                </h1>

                <p className="font-size-h5 font-weight-bold text-dark-75 mb-5">
                  Saat ini sistem sedang menjalani proses pemeliharaan dan
                  peningkatan layanan.
                </p>

                <p className="text-muted font-weight-normal mb-8">
                  Kami sedang melakukan pembaruan untuk meningkatkan performa,
                  keamanan, dan kualitas layanan. Selama proses ini berlangsung,
                  akses ke sistem untuk sementara waktu tidak tersedia.
                </p>

                <div className="alert alert-custom alert-light-warning rounded mb-8">
                  <div className="alert-text font-weight-bold">
                    Silakan coba kembali beberapa saat lagi. Terima kasih atas
                    pengertian dan kesabaran Anda.
                  </div>
                </div>

                <button
                  className="btn btn-primary font-weight-bold px-9 py-4 my-3"
                  onClick={this.handleRefresh}
                >
                  <span className="fa fa-refresh mr-2" />
                  Muat Ulang
                </button>
              </div>
            </div>

            <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-center align-items-center mt-5 p-5">
              <div className="text-white font-weight-bold my-2">
                &copy; 2021 Sistem Penjaminan Mutu Internal
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Maintenance;
